var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "search_shop_config",
      attrs: { model: _vm.value.config, disabled: _vm.disabled },
    },
    [
      _c("div", { staticClass: "tips" }, [
        _vm._v(
          " 暂无配置项，每个页面只能有一个" +
            _vm._s(_vm.value.widget) +
            "，位置无法移动 "
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }